import { Avatar } from "@circle-react-uikit/SkeletonLoader/components/Avatar";
import { AvatarContainer } from "@circle-react-uikit/SkeletonLoader/components/AvatarContainer";
import { Row } from "@circle-react-uikit/SkeletonLoader/components/Row";
import { RowContainer } from "@circle-react-uikit/SkeletonLoader/components/RowContainer";

const renderAvatarContainer = (index: number) => (
  <div key={index} className="p-5">
    <AvatarContainer md full>
      <Avatar />
      <RowContainer full>
        <Row md />
        <Row md full />
      </RowContainer>
    </AvatarContainer>
  </div>
);

export const ChatThreadsListPage = () => (
  <div className="p-6">
    <div className="mb-4">
      <RowContainer full>
        <Row md />
        <Row md half />
      </RowContainer>
    </div>
    <RowContainer lg full>
      <div className="bg-primary border-primary mb-14 divide-y rounded-xl border">
        {Array.from(Array(4).keys()).map(renderAvatarContainer)}
      </div>
    </RowContainer>
    <div className="mb-4">
      <RowContainer full>
        <Row md />
        <Row md half />
      </RowContainer>
    </div>
    <RowContainer lg full>
      <div className="bg-primary border-primary mb-14 divide-y rounded-xl border">
        {Array.from(Array(3).keys()).map(renderAvatarContainer)}
      </div>
    </RowContainer>
  </div>
);
